import { api } from '../api-client.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { PuzzleItem } from '../types';

const createPuzzleItem = (puzzleItem: PuzzleItem) =>
  api.post(`/puzzle-item`, puzzleItem);

export const useCreatePuzzleItemMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['create-puzzle-item'],
    mutationFn: createPuzzleItem,
    onSuccess: () => {
      toast.success('Puzzle item created successfully');

      queryClient.invalidateQueries({
        queryKey: ['puzzle-items'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
